import { render } from "./translation_table.vue?vue&type=template&id=d3180110"
import script from "./translation_table.vue?vue&type=script&lang=js"
export * from "./translation_table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__